const COMMENTS = [
  {
    id: 1,
    name: '影视爱好者小王',
    date: '2026-07-28',
    content: '91视频网站真的太棒了！一直想找91年的国产老电影，在这里全都找到了。画质清晰流畅，分类也很全，从电影到电视剧再到综艺，每天都有新内容更新，推荐给所有喜欢国产影视的朋友。',
    rating: 5,
  },
  {
    id: 2,
    name: '经典剧迷',
    date: '2026-07-26',
    content: '作为一个国产电视剧的铁杆粉丝，91视频网站的片库让我惊喜。91年国产影片专区做得特别用心，很多小时候看过的老剧都在这里重温了一遍。界面简洁没有乱七八糟的广告，观影体验很好。',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜追剧人',
    date: '2026-07-24',
    content: '每天晚上都要来91视频网站逛一圈，看看有什么新上的国产剧和综艺。更新速度很快，高清播放很流畅。最喜欢91国产视频专区，内容质量很高，已经推荐给了身边好多朋友。',
    rating: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">用户评价</h2>
          <p className="text-sm md:text-base text-foreground-500">来自91国产视频用户的真实反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${i < comment.rating ? 'text-accent-500' : 'text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}